export default "__VITE_ASSET__C1z3Uh2l__"